import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
// google maps
import { AgmCoreModule } from '@agm/core';
import { ResaltarDirective } from './directives/resaltar.directive';
import { ContarClicksDirective } from './directives/contar-clicks.directive';
import { Routes, RouterModule } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DetalleComponent } from './detalle/detalle.component';
import { LugaresComponent } from './lugares/lugares.component';
import { ContactoComponent } from './contacto/contacto.component';
import { CrearComponent } from './crear/crear.component';
//  S E R V I C E S 
import { LugaresService } from './services/lugares.service';
import { GeolocationService } from './services/geolocation.service';
// F I R E B A S E
import {environment} from '../environments/environment';
import {AngularFireModule} from 'angularfire2';
import {AngularFirestoreModule} from 'angularfire2/firestore';
import {AngularFireStorageModule} from 'angularfire2/storage';
import {AngularFireAuthModule} from 'angularfire2/auth';
// modulo actualizado
import { AngularFireDatabaseModule } from'angularfire2/database';
import { HttpModule } from '@angular/http';
import { LinkifystrPipe } from './pipes/linkifystr.pipe';
import { LoginComponent } from './login/login.component';
import { RegistroComponent } from './registro/registro.component';
import { AutorizacionService } from './services/autorizacion.service';
import { MyGuardService } from './services/my-guard.service';
//import { RegistroComponent } from './registro/registro.component';
// Sweet Alert

//import { ContarClicksDirective } from './directives/contar-clicks.directive';

// ahora se implementa el Ruteo
const appRoutes: Routes = [
  {path:'', component: LugaresComponent},
  {path:'home', component: LugaresComponent},  
  {path:'contacto', component: ContactoComponent},
  {path:'login', component: LoginComponent},
  {path:'registro', component: RegistroComponent},
  {path:'crear/:id', component: CrearComponent, canActivate:[MyGuardService]}, // Ir a crear Lugar
  {path:'lugares', component: LugaresComponent}, // asignar la ruta al nuevo compoent
  {path:'detalle/:id', component: DetalleComponent} // param de la ruta <---
];

@NgModule({
  declarations: [ 
    AppComponent,
    ResaltarDirective,
    ContarClicksDirective,
    DetalleComponent,
    LugaresComponent,
    ContactoComponent,
    CrearComponent,
    LinkifystrPipe,
    LoginComponent,
    RegistroComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDTFhjKoFGDspQ1U3utH3lVmIGLr6G5Axc'
    }),
    BrowserAnimationsModule,
    RouterModule.forRoot(appRoutes),
    AngularFireModule.initializeApp(environment.firebase, 'platzi-square-jdiaz'),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    HttpModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserModule
  ],
  providers: [
    LugaresService,
    GeolocationService,
    AutorizacionService,
    MyGuardService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/USUARIO/Documents/Platzi/cursos__2017/Angular_4_PROFESIONAL/proyectos/platzisquare2/src/app/app.module.ts